module.exports = __webpack_public_path__ + "img/classroom_and_organization_chat.c53a17ed.svg";